// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".certification-container[data-v-51c04de4]{max-width:888px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
